import { Contract } from '@/modules/Contract/types'
import { formatCurrency } from '@/utils/function'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@/components/ui/card'
import { Typogaphy } from 'vnetwork-ui'

const Total = () => {
    const { t } = useTranslation()
    const { control } = useFormContext<Contract>()

    const order_amount = useWatch({
        control,
        name: 'order.order_amount',
    })

    const currency_code = useWatch({
        control,
        name: 'currency_code',
    })

    return (
        <Card className="border-2">
            <CardContent className="p-4">
                <div className="flex items-center justify-between gap-4">
                    <Typogaphy
                        size="small"
                        className="text-muted-foreground capitalize"
                    >
                        {t('total')}
                    </Typogaphy>
                    <Typogaphy className="font-bold tracking-tight text-2xl">
                        {formatCurrency(order_amount, currency_code)}
                    </Typogaphy>
                </div>
            </CardContent>
        </Card>
    )
}

export default Total
